import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 0px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-start: 0px;
    padding-block-end: 70px;
  }
  ${device.large} {
    padding-block-start: 0px;
    padding-block-end: 90px;
  }
  ${color}
`

export const StyledText = styled.div`
  margin-block-start: 15px;
  margin-block-end: 25px;
  font-size: 18px;
  margin-inline-start: 34px;
  margin-inline-end: 34px;
`

export const SwiperWrapper = styled.div`
  padding-block-start: 110px;
`

export const SlideItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: ${(props) => props.width}px;
  max-width: 210px;
  height: 75px;

  padding: 1px;
  opacity: 0.5;
  filter: grayscale(1);
  transition: all 0.2s ease;
  &:hover {
    own-swiper-slide {
      swiper-slide {
        opacity: 1 !important;
      }
    }
    filter: grayscale(0);
    opacity: 1;
    cursor: pointer;
  }
`
